// extracted by mini-css-extract-plugin
module.exports = {"rcorners3":"SmallWindowBox_rcorners3__3Jr4r","centerDiv":"SmallWindowBox_centerDiv__35U4D","buttonWidth":"SmallWindowBox_buttonWidth__1eDHT"};